import type { IWatermarkElement } from '@/types/watermarks.types';
import { useState, useRef, useEffect } from 'react';
import TextEl from './text';
import { formatWatermarkDateTime } from '../utils/format-watermark-date';

const liveNow = () => formatWatermarkDateTime(new Date(), null, Intl.DateTimeFormat().resolvedOptions().timeZone);

const DateEl = (el: IWatermarkElement) => {
  const savedValue = el.settings.text.value;
  const [liveDate, setLiveDate] = useState(liveNow);
  const interval = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (savedValue) return;

    interval.current = setInterval(() => {
      setLiveDate(liveNow());
    }, 60000); // check the date each minute

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, [savedValue]);

  return <TextEl {...el} settings={{ ...el.settings, text: { ...el.settings.text, value: savedValue || liveDate } }} />;
};

export default DateEl;
